export const formLayoutMixin = {
    computed: {
        formItemLayout() {
            const {
                formLayout
            } = this;
            return formLayout === 'horizontal' ? {
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 14
                },
            } : {};
        },
        buttonItemLayout() {
            const {
                formLayout
            } = this;
            return formLayout === 'horizontal' ? {
                wrapperCol: {
                    span: 14,
                    offset: 4
                },
            } : {};
        }
    }
}